import React from 'react';
import ConfirmationDialog from './ConfirmationDialog';

/**
 * Wrapper for ConfirmationDialog component that renders either bare button or also adds a confirmation step through the confirmation dialog.
 *
 * @param {React.ReactNode} ButtonComponent
 * @param {Object} buttonProps
 * @param {Object} dialogProps
 * @param {boolean} useConfirmation
 * @returns {React.ReactElement}
 */
function ConfirmationDialogWrapper({
  ButtonComponent,
  buttonProps,
  dialogProps,
  useConfirmation,
  timestamp,
  location,
  handleGTMAppointmentTimeSelectedEvent,
  showTimeSlots,
}) {
  if (!useConfirmation) return <ButtonComponent {...buttonProps}>{buttonProps.text}</ButtonComponent>;

  return (
    <ConfirmationDialog
      ButtonComponent={ButtonComponent}
      buttonProps={buttonProps}
      onConfirm={buttonProps.onClick}
      {...dialogProps}
      timestamp={timestamp}
      location={location}
      handleGTMAppointmentTimeSelectedEvent={handleGTMAppointmentTimeSelectedEvent}
      showTimeSlots={showTimeSlots}
    />
  );
}

export default ConfirmationDialogWrapper;
